import { MarketPricesWrapper } from "./market-prices.style";
import { MarketPriceHistorySection } from "./sections/market-price-history.section";

export const MarketPriceHistoryPage = () => <MarketPricesWrapper><MarketPriceHistorySection /></MarketPricesWrapper>;
